const languages = {
  FR: 'fr',
  CN: 'zh',
  HK: 'zh',
  MO: 'zh',
  TW: 'zh',
};

export default languages;
